export default "/kiban/_next/static/images/12_6L_1-4-1_withoutBH-cfc023274dc8a65b89537faae9f5b260.png";